import { canUseNative, useAuth0 } from "~/config/auth0/use-auth0";
import { useFirebaseToken } from "~/config/capacitor/push-notifications/PushNotifications";
import { env } from "~/config/env";
import { useDeleteFirebaseTokenMutation } from "./useLogout.graphql";

const useLogout = () => {
  const firebaseToken = useFirebaseToken((state) => state.token);
  const [, deleteFirebaseToken] = useDeleteFirebaseTokenMutation();
  const { logout } = useAuth0();

  return {
    logout: async () => {
      if (firebaseToken) {
        await deleteFirebaseToken({ input: { token: firebaseToken } }).catch(
          (error) => {
            console.error(error);
          }
        );
      }
      await logout(
        canUseNative()
          ? undefined
          : {
              logoutParams: {
                returnTo: env.VITE_APP_BASE_URL,
              },
            }
      );
    },
  };
};

export { useLogout };
